import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IoIosClose } from 'react-icons/io';
import isEmpty from 'lodash/isEmpty';
import { AuthContext } from 'context/AuthProvider';
import Button from 'components/UI/Antd/Button/Button';
import {Button as CustomButton } from 'components/common/Button';
import Modal from 'components/UI/Antd/Modal/Modal';
import StickyBooking from 'components/StickyBooking/StickyBooking';
import { getStateFromUrl } from 'library/helpers/url_handler';
import Reservation from './Reservation';
import MarinaReservation from 'container/Reservation/MarinaReservation';
import smallLogo from 'assets/images/pickapier/logo_horizontal.svg';

// import Rating from 'components/UI/Rating/Rating';

const BottomReservation = ({ marina, location, history, promotions }) => {
  const { t } = useTranslation();
  const { loggedIn } = useContext(AuthContext);
  const searchParams = getStateFromUrl(location);
  const [visible, setVisible] = useState(false);
  const { name: title, price, rating, ratingCount, marina_settings } = marina;
  const { instant_booking } = marina_settings;

  useEffect(() => {
    if (
      loggedIn &&
      !isEmpty(searchParams) &&
      searchParams.create_reservation === 'true'
    ) {
      setVisible(true);
    }
  }, [loggedIn]);

  return (
    <>
      <StickyBooking
        logo={smallLogo}
        title={null}
        price={null}
        rating={null}
        marina={marina}
        action={
          <CustomButton
            fillWidth
                      label={
                         t("BOOK_NOW")
                      }
                      onClick={e => {
                        
                        window.location.hash = `#reservation`;
                          console.log("clicked")
                      }}
          />
        }
      />
    </>
  );
};

export default BottomReservation;
